<template>
  <div class="platform-value">
    <app-header></app-header>

    <!-- 轮播图 -->
    <!-- 轮播外层 -->
    <div class="swiper-box">
      <!-- 轮播外层 -->
      <swiper ref="mySwiper" :options="swiperOptions">
        <!-- 轮播项 -->
        <swiper-slide v-for="(slide, index) in carouselSlides" :key="index">
          <img :src="slide.bgImage" alt="" />
          <div class="slide-content">
            <div class="container">
              <div class="slide-text-content">
                <p class="slide-en-title">{{ slide.enTitle }}</p>
                <h1 class="slide-title">{{ slide.title }}</h1>
              </div>
            </div>
          </div>
        </swiper-slide>

        <!-- 小圆点 -->
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>

    <!-- 团队长端（微信小程序） -->
    <section class="section section-right">
      <div class="content">
        <img src="@/assets/ProductSystem/icon01.png" alt="" class="image" />
        <dl>
          <dt>团队长端（微信小程序）</dt>
          <dd>团队架构管理</dd>
          <dd>业务员拓展与管理</dd>
          <dd>终端开发统计与考核</dd>
          <dd>业绩实时查看与分析</dd>
          <dd>账号状态与合规管理</dd>
        </dl>
      </div>
    </section>

    <!-- 业务员端（微信小程序） -->
    <section class="section section-left section-gray">
      <div class="content">
        <dl>
          <dt>业务员端（微信小程序）</dt>
          <dd>个人专属绑定码</dd>
          <dd>药店/诊所/医院扫码绑定</dd>
          <dd>品种分享与推广授权</dd>
          <dd>终端维护与动销跟进</dd>
          <dd>个人业绩与考核中心</dd>
        </dl>
        <img src="@/assets/ProductSystem/icon01.png" alt="" class="image" />
      </div>
    </section>

    <!-- 药店端（微信小程序） -->
    <section class="section section-right section-white">
      <div class="content">
        <img src="@/assets/ProductSystem/icon01.png" alt="" class="image" />
        <dl>
          <dt>药店端（微信小程序）</dt>
          <dd>合作业务员确认</dd>
          <dd>产品接收与授权同意</dd>
          <dd>动销信息查看</dd>
          <dd>服务沟通与订单协同</dd>
          <dd>合作资质与记录留存</dd>
        </dl>
      </div>
    </section>

    <app-footer></app-footer>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'

export default {
  name: 'ProductSystem',
  components: {
    AppHeader,
    AppFooter,
  },
  data() {
    return {
      swiperOptions: {
        // 👇 最常用配置（直接用）
        loop: true, // 无限循环
        // autoplay: false,
        autoplay: {
          delay: 3000, // 3秒切换一次
          disableOnInteraction: false, // 滑动后不停止自动轮播
          pauseOnMouseEnter: false,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true, // 小圆点可点击
        },
        speed: 600, // 切换速度
        slidesPerView: 1, // 一屏显示几张
        spaceBetween: 0, // 图片间距
        effect: 'slide',
      },
      carouselSlides: [
        {
          bgImage: require('@/assets/ProductSystem/banner01.png'),
          enTitle: 'Four in One · Full Link Digital Management System',
          title: '四端一体 · 全链路数字化管理系统',
        },
        {
          bgImage: require('@/assets/ProductSystem/banner01.png'),
          enTitle: 'Four in One · Full Link Digital Management System',
          title: '四端一体 · 全链路数字化管理系统',
        },
        {
          bgImage: require('@/assets/ProductSystem/banner01.png'),
          enTitle: 'Four in One · Full Link Digital Management System',
          title: '四端一体 · 全链路数字化管理系统',
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
.platform-value {
  padding-top: 80px;
}

/* 轮播图样式 */
.swiper-box {
  width: 100%;
  height: 800px;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.slide-content {
  position: absolute;
  top: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

:deep(.swiper-container) {
  height: 100%;
}
:deep(.swiper-pagination-bullet) {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #ffffff;
  margin: 0 18px !important;
  opacity: 1 !important;
  &.swiper-pagination-bullet-active {
    border-radius: 5px 5px 5px 5px;
    width: 56px;
  }
}
.slide-text-content {
  text-align: center;
  color: #fff;
}

.slide-en-title {
  font-size: 24px;
  color: #fff;
  margin-bottom: 20px;
  letter-spacing: 2px;
  opacity: 0.9;
  text-transform: uppercase;
}

.slide-title {
  font-size: 64px;
  color: #fff;
  font-weight: bold;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

/* 团队长端（微信小程序） */
.section {
  background: linear-gradient(180deg, #1ca19630 0%, #ffffff 100%);
  height: 821px;
  &.section-white {
    background: #ffffff !important;
  }
  &.section-gray {
    background: #f5f5f5 !important;
  }
  .content {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .image {
      width: 376px;
      height: 376px;
      border-radius: 20px;
      box-shadow: 0px 4px 16px 0px #1ca19640;
    }
    dl {
      padding: 0;
      dt {
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-style: normal;
        font-size: 30px;
        letter-spacing: 0;
        color: #000000;
        line-height: 40px;
        height: 40px;
        margin-bottom: 40px;
      }
      dd {
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-style: normal;
        font-size: 20px;
        letter-spacing: 0;
        line-height: 26px;
        height: 26px;
        margin: 0;
        margin-bottom: 28px;
        &::before {
          content: '';
          width: 12px;
          height: 12px;
          display: inline-block;
          background: #1ca196;
          border-radius: 50%;
          margin-right: 19px;
        }
      }
    }
  }
}

.section-right {
  background-color: #f5f5f5;
  dl {
    margin: 0;
    margin-left: 121px;
  }
  .image {
    margin-left: 0;
  }
}

/* 业务员端（微信小程序） */
.section-left {
  background-color: #f5f5f5;
  dl {
    margin: 0;
    margin-left: 0;
  }
  .image {
    margin-left: 121px;
  }
}

/* 响应式设计 */
@media (max-width: 1200px) {
}

@media (max-width: 768px) {
}
</style>
